// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"69":"locale-es-json","96":"vendors","990":"locale-en-json"}[chunkId] || chunkId) + ".js";
};